<template>
    <div>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1920 135">
            <path :style="{fill: color}"
                  d="M0,55.94a1491,1491,0,0,0,276.85,54.38c104.8,10.41,202,8.77,377.3-8.86C881.09,78.64,894,63.73,1146.43,31.89,1473.56-9.36,1595.56-2.42,1682,7.9a1514.81,1514.81,0,0,1,238,48q0,39.53,0,79.06H0Z"/>
        </svg>
        <slot/>
    </div>
</template>

<script>
export default {
    name: "CanvasTopCurve",
    props: {
        color: {
            type: String,
            default: '#333333',
        }
    }
}
</script>
